<template>
    <v-content style="height: 100%;" class="px-0 mx-auto">
        <v-row v-if="validateLoad==true" justify="center" align="center">
            <v-col calign-self="center" cols="auto">
                 <v-row justify="center" >
                    <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                     ></v-progress-circular>                        
                </v-row> 
            </v-col>
        </v-row>
        <v-row v-else style="max-width: 600px; margin: 0 auto;" >
            <v-col id="base" md="12" style="height: 100%;" class="mt-0 pt-0" >
                <!-- Pedidos -->
            <v-row justify="start" align="center" style="height:35px; background-color: #F2F2F2;" class="pt-0">
                <!-- <v-btn @click="$router.push({ name: 'menu'})" icon x-large :color="$store.state.colors.primary" style="margin-left: 30px;">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn> -->
            </v-row>
            <v-row justify="start" style="font-size: 23px" class="RestoRegular ml-4 mt-2">
                Pedidos
            </v-row>
            <v-row v-if="orders.length == 0" justify="center" align="start" class="mt-10 RestoRegular" style="width: 95%; margin: 0 auto">
                No existe ningun pedido por entregar en este momento
            </v-row>
            <v-row v-else justify="center" align="start" style="width: 95%; margin: 0 auto">
                <v-col>
                    <v-row v-for="(order, index) in orders" :key="index" style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                        <v-col align-self="center" cols="auto">
                            <v-img src="@/assets/resources/user/casa.svg" max-width="25px"></v-img>
                        </v-col>
                        <v-col align-self="center" style="font-size: 12px" class="RestoRegular">
                            <v-row class="RestoBold" style="font-size: 13px">
                               PEDIDO {{order.estatus}}
                            </v-row>
                            <v-row>
                                {{order.fecha_alta.substr(0,10)}}
                            </v-row>
                            <v-row>
                                Entregar a {{order.nombre}}
                            </v-row>
                            <v-row>
                                Dirección: {{order.calle}} #{{order.num_exterior}} int {{order.num_interior}}, {{order.colonia}}
                            </v-row>
                            <v-row>
                                Teléfono: {{order.telefono}}
                            </v-row>
                        </v-col>
                        <v-col align-self="center" cols="auto">
                            <a @click="details(index);$router.push({ name: 'orders_detail_delivery',params:{id:idOrder, id_client: orders[index].id_cliente }});" style="font-size: 14px; background-color: transparent;" class="RestoBold" :style="{ 'color': $store.state.colors.primary }">
                                Detalles
                            </a>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>


  export default {
    data () {
      return {
        idOrder:null,
        sizeP: null,
        sizeF: null,
        image: "test",
        activeColor: '#E5DFDE',
        orders:[],
        newmenu: [],
        validateLoad:true,
      }
    },
    methods: {
        clicked(value)
        {
            console.log(value);
            this.activeColor = "#A8A8A8";
        },
        scrollTo(id) {
            console.log(id);

            document.getElementById(id).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        },
        details(index)
        {
            // this.id_client = this.orders[index].id;
            this.idOrder=this.orders[index].id;
        }
    },
    mounted() {

    },
    created() {
        this.$store.state.validationDelivery=true;
        console.log(localStorage.getItem("id_repartidor"));
        this.$store.dispatch("GET", {url: '/pedidos_rep/'+localStorage.getItem("id_repartidor"), headers: {Authorization: this.$store.state.tokenDM}})
            .then(response => {
                console.log("PEDIDOS REP:", response);
                this.orders=response.data;
                console.log(this.orders.length);
                this.validateLoad=false;
            })// eslint-disable-next-line
            .catch(error => {
                // eslint-disable-next-line
                console.log("Error: " + error);
                localStorage.removeItem('tokenDM'); 
                this.$store.state.tokenDM = null; 
                localStorage.removeItem('id_repartidor'); 
                localStorage.removeItem('id_sucursal');
                this.$store.state.id_sucursal = null; 
                // this.$router.push({ name: 'loginDeliveryMan'});
                location.reload();
                this.dialogDM=false;
                this.$store.state.validationDelivery=false;
                this.$store.state.logo = false;
            });
    }
  }
</script>

<style scoped>

    .cards {
        background-color: #EEEEEE ;
        color: #BFBBBA ;
    }
    .cards:focus, .cards:hover {
        background-color: #A8A8A8;
        color: white;
    }

    div.sticky {
        position: -webkit-sticky;
        position: sticky;
        top: -1px;
        z-index: 1;
        }
    
</style>